@if (option.familyAllowed && form.get('othersEnabled')?.value) {
@for (other of othersArray.controls; let i = $index; track i) {
<div [formGroup]="other" class="py-3 border-top">
    <div class="d-flex align-items-end justify-content-between gap-2 mb-2">
        <div class="flex-grow-1">
            <label [for]="'insuranceItemRelationOther' + i"
                class="form-label small fw-semibold text-muted text-uppercase uppercase">Parentesco</label>
            <select [id]="'insuranceItemRelationOther' + i" formControlName="relationship"
                class="form-select py-2 focus-ring fw-bold focus-ring-success"
                [class.border-danger]="other.get('relationship')?.touched && other.get('relationship')?.invalid"
                [class.border-success]="other.get('relationship')?.valid && other.get('relationship')?.value">
                <option [ngValue]="null" disabled>Seleccione</option>
                @for (rel of relationships; track rel.value) {
                <option [ngValue]="rel.value">{{ rel.label }}</option>
                }
            </select>
            @if (other.get('relationship')?.touched && other.get('relationship')?.hasError('required')) {
            <div class="text-danger small mt-1">Debe seleccionar el parentesco.</div>
            }
        </div>
        <button (click)="removeOther(i)" class="btn btn-outline-danger border-2 btn-sm rounded-3" type="button">
            <app-icon [size]="24" [strokeWidth]="2" name="user-minus"></app-icon>
        </button>
    </div>
    <div class="row align-items-end">
        <div class="col-12 col-md-4">
            <label [for]="'insuranceItemBirthDateOther' + i"
                class="form-label small fw-semibold text-muted text-uppercase uppercase">Fecha de nacimiento</label>
            <app-datepicker-input [id]="'insuranceItemBirthDateOther' + i" formControlName="birthDate"
                [control]="other.get('birthDate')" inputClass="form-control py-2 focus-ring fw-bold focus-ring-success"
                [errorMessages]="{
                                  required: 'La fecha de nacimiento es obligatoria',
                                  invalidBirthDate: 'Fecha no válida',
                                  minAge: 'El familiar debe tener al menos ' + (option.minAge != null && option.minAge > 18 ? option.minAge : 18) + ' años',
                                  maxAge: 'El familiar debe tener como máximo ' + option.maxAge + ' años'
                                }"></app-datepicker-input>
        </div>
        <div class="col">
            <div class="form-label small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Sexo</div>
            <div class="d-flex gap-2">
                <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
                    <input [id]="'insuranceSexOther' + i + '1'" [value]="Gender.F"
                        class="form-check-input focus-ring focus-ring-success" formControlName="gender" type="radio">
                    <label [for]="'insuranceSexOther' + i + '1'" class="form-check-label fw-bold">Femenino</label>
                </div>
                <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
                    <input [id]="'insuranceSexOther' + i + '2'" [value]="Gender.M"
                        class="form-check-input focus-ring focus-ring-success" formControlName="gender" type="radio">
                    <label [for]="'insuranceSexOther' + i + '2'" class="form-check-label fw-bold">Masculino</label>
                </div>
            </div>
            @if (other.get('gender')?.touched && other.get('gender')?.hasError('required')) {
            <div class="text-danger small mt-1">Debe seleccionar el sexo.</div>
            }
        </div>
    </div>
</div>
}
<div class="row g-3 mt-2">
    <div class="col-12">
        <button (click)="addOther()" class="btn fw-semibold btn-outline-success border-2 btn-sm rounded-3"
            type="button">
            <app-icon [size]="24" [strokeWidth]="2" name="user-plus"></app-icon>
            Agregar otro familiar
        </button>
    </div>
</div>
}